import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "@/components/layout/Logo";

const columns = [
  {
    title: "Solutions",
    links: [
      { label: "Licara Platform", to: "/solutions/licara" },
      { label: "Our Approach", to: "/solutions" },
      { label: "Request a Demo", to: "/demo" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Sentira", to: "/about" },
      { label: "Careers", to: "/careers" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-border bg-[hsl(220_35%_4%)]"
    >
      <div className="mx-auto max-w-[var(--container-max)] px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
              Enterprise-grade software for modern public operations. We build
              mission-critical systems for agencies and enterprises — starting
              with Licara.
            </p>
            <div className="mt-6 space-y-2 text-sm text-muted-foreground">
              <a
                href="mailto:hello@sentira.io"
                data-testid="footer-email-link"
                className="flex items-center gap-2 transition-colors hover:text-foreground"
              >
                <Mail className="h-4 w-4 text-primary" />
                hello@sentira.io
              </a>
              <p className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-primary" />
                Austin, TX · Remote-first
              </p>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              Get started
            </h4>
            <p className="mt-4 text-sm text-muted-foreground">
              See how Licara unifies enforcement operations.
            </p>
            <Link
              to="/demo"
              data-testid="footer-demo-link"
              className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary transition-colors hover:text-[hsl(173_80%_52%)]"
            >
              Book a demo
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-border pt-8 text-sm text-muted-foreground sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Sentira. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <span className="font-mono text-xs uppercase tracking-widest">
              Privacy
            </span>
            <span className="font-mono text-xs uppercase tracking-widest">
              Terms
            </span>
            <span className="font-mono text-xs uppercase tracking-widest">
              Security
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
